import { render } from "@/components/organisms/memoPage/MemoPage.html?vue&type=template&id=79851f70&external"
import script from "@/components/organisms/memoPage/MemoPage.js?vue&type=script&lang=js&external"
export * from "@/components/organisms/memoPage/MemoPage.js?vue&type=script&lang=js&external"

import "@/components/organisms/memoPage/MemoPage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__